var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPixel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9BAAAB"
    },
    d: "M100.244,374.568v-43.116c0-4.465-3.62-8.084-8.084-8.084H49.044c-4.465,0-8.084,3.62-8.084,8.084 v43.116c0,4.465,3.62,8.084,8.084,8.084H92.16C96.625,382.653,100.244,379.033,100.244,374.568z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CDD4D5"
    },
    d: "M277.558,452.716h-43.116c-4.465,0-8.084,3.62-8.084,8.084v43.116c0,4.465,3.62,8.084,8.084,8.084 h43.116c4.465,0,8.084-3.62,8.084-8.084V460.8C285.642,456.335,282.023,452.716,277.558,452.716z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9BAAAB"
    },
    d: "M195.638,439.781h-43.116c-4.465,0-8.084,3.62-8.084,8.084v43.116c0,4.465,3.62,8.084,8.084,8.084 h43.116c4.465,0,8.084-3.62,8.084-8.084v-43.116C203.722,443.401,200.103,439.781,195.638,439.781z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CDD4D5"
    },
    d: "M126.653,392.354H83.537c-4.465,0-8.084,3.62-8.084,8.084v43.116c0,4.465,3.62,8.084,8.084,8.084 h43.116c4.465,0,8.084-3.62,8.084-8.084v-43.116C134.737,395.973,131.117,392.354,126.653,392.354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CDD4D5"
    },
    d: "M480.202,254.383h-43.116c-4.465,0-8.084,3.62-8.084,8.084v43.116c0,4.465,3.62,8.084,8.084,8.084 h43.116c4.465,0,8.084-3.62,8.084-8.084v-43.116C488.286,258.003,484.667,254.383,480.202,254.383z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9BAAAB"
    },
    d: "M462.956,323.368H419.84c-4.465,0-8.084,3.62-8.084,8.084v43.116c0,4.465,3.62,8.084,8.084,8.084 h43.116c4.465,0,8.084-3.62,8.084-8.084v-43.116C471.04,326.988,467.42,323.368,462.956,323.368z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9BAAAB"
    },
    d: "M359.478,439.781h-43.116c-4.465,0-8.084,3.62-8.084,8.084v43.116c0,4.465,3.62,8.084,8.084,8.084 h43.116c4.465,0,8.084-3.62,8.084-8.084v-43.116C367.562,443.401,363.943,439.781,359.478,439.781z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CDD4D5"
    },
    d: "M428.463,392.354h-43.116c-4.465,0-8.084,3.62-8.084,8.084v43.116c0,4.465,3.62,8.084,8.084,8.084 h43.116c4.465,0,8.084-3.62,8.084-8.084v-43.116C436.547,395.973,432.928,392.354,428.463,392.354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CDD4D5"
    },
    d: "M82.998,305.583v-43.116c0-4.465-3.62-8.084-8.084-8.084H31.798c-4.465,0-8.084,3.62-8.084,8.084 v43.116c0,4.465,3.62,8.084,8.084,8.084h43.116C79.378,313.667,82.998,310.048,82.998,305.583z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4ACFD9"
    },
    d: "M304.978,2.517C303.451,0.91,301.332,0,299.116,0h-86.232c-2.216,0-4.336,0.91-5.863,2.517 c-1.526,1.607-2.326,3.772-2.212,5.984l12.935,250.072c0.222,4.296,3.772,7.667,8.073,7.667h60.362c4.303,0,7.851-3.37,8.073-7.667 L307.188,8.501C307.303,6.288,306.504,4.125,304.978,2.517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#87999B"
    },
    d: "M217.745,258.573c0.222,4.296,3.772,7.667,8.073,7.667h60.362c4.303,0,7.851-3.37,8.073-7.667 l7.137-137.971h-90.782L217.745,258.573z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD1A9"
    },
    d: "M256,206.956c-44.874,0-81.381,36.507-81.381,81.381c0,18.151,12.66,50.668,37.628,96.646 c18.25,33.608,36.755,62.633,36.941,62.922c1.485,2.325,4.054,3.732,6.812,3.732c2.758,0,5.327-1.407,6.812-3.732 c0.184-0.29,18.69-29.314,36.939-62.922c24.969-45.979,37.629-78.496,37.629-96.646C337.381,243.463,300.874,206.956,256,206.956z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0295AA"
    },
    d: "M212.884,0c-2.216,0-4.336,0.91-5.863,2.517c-1.526,1.607-2.326,3.772-2.212,5.984l12.935,250.072 c0.222,4.296,3.772,7.667,8.073,7.667h29.258V0H212.884z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#687F82"
    },
    d: "M210.609,120.602l7.137,137.971c0.222,4.296,3.772,7.667,8.073,7.667h29.258V120.602H210.609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8C29"
    },
    d: "M174.619,288.337c0,18.151,12.66,50.668,37.628,96.646c18.25,33.608,36.755,62.633,36.941,62.922 c1.318,2.063,3.49,3.398,5.89,3.673V206.979C210.629,207.479,174.619,243.772,174.619,288.337z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M264.394,373.468c-1.302,0-2.623-0.316-3.848-0.98c-3.925-2.129-5.38-7.036-3.251-10.961 c6.604-12.174,12.339-23.444,17.042-33.5c1.892-4.043,6.705-5.789,10.748-3.898c4.044,1.892,5.789,6.703,3.898,10.748 c-4.839,10.345-10.717,21.904-17.475,34.359C270.042,371.936,267.263,373.468,264.394,373.468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M290.909,317.981c-0.958,0-1.932-0.171-2.88-0.534c-4.171-1.592-6.264-6.264-4.672-10.435 c4.964-13.011,5.479-18.279,5.519-18.795c-0.065-18.073-14.788-32.757-32.876-32.757c-4.465,0-8.084-3.62-8.084-8.084 c0-4.465,3.62-8.084,8.084-8.084c27.043,0,49.044,22.001,49.044,49.044c0,1.687-0.474,8.433-6.581,24.44 C297.234,316,294.164,317.981,290.909,317.981z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPixel);
export default __webpack_public_path__ + "static/media/pixel.2fdda27a1166c2b53b0a6216785fb702.svg";
export { ForwardRef as ReactComponent };